import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { H3, ProgressBar, Text } from '../../../../../components';
import { AnswerTips } from '../AnswerTips';

const AnswerProgressContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: ${({ $small }) => ($small ? 'auto' : '100%')};
  justify-content: center;
  align-items: ${({ $small }) => ($small ? 'flex-end' : 'center')};
  row-gap: ${({ $small }) => ($small ? '8px' : '24px')};
  height: ${({ $small }) => ($small ? 'auto' : '400px')};
`;

const AnswerProgress = ({
  className = null,
  message,
  progress,
  small = false,
  isRetry = false
}) => (
  <AnswerProgressContainer $small={small} className={className}>
    {small ? (
      <Text color='var(--content-body)'>{message}</Text>
    ) : (
      <H3 color='var(--content-body)'>{message}</H3>
    )}
    <ProgressBar progress={progress} total={100} small={small} />
    {!small && <AnswerTips />}

    {!small && isRetry && (
      <H3 color='var(--content-subtitle)'>
        Looks like that answer wasn&apos;t quite right &mdash; trying again!
      </H3>
    )}
  </AnswerProgressContainer>
);

AnswerProgress.propTypes = {
  className: PropTypes.string,
  small: PropTypes.bool,
  message: PropTypes.string.isRequired,
  progress: PropTypes.number.isRequired,
  isRetry: PropTypes.bool
};

export { AnswerProgress };
